export class UrlReloadService {
  private param = 'reload';
  private maxReloadCount = 3;
  private url: URL;

  constructor(url: URL) {
    this.url = url;
  }

  public reload(): void {
    let urlString = this.url.search;
    if (!this.url.searchParams.has(this.param)) {
      urlString = `${this.param}=0&${this.url.searchParams.toString()}`;
    }

    const searchParams = new URLSearchParams(urlString);
    if (!this.isMaxReloadExceeded) {
      searchParams.set(this.param, String(this.reloadCount + 1));
      this.url.search = searchParams.toString();
      window.location.href = this.url.toString();
    }
  }

  public reloadOnChunkError(): void {
    window.onunhandledrejection = (event: PromiseRejectionEvent) => {
      if (
        event.reason &&
        event.reason instanceof Error &&
        event.reason.message.includes('isProxied')
      ) {
        this.reload();
      }
    };
  }

  public get isMaxReloadExceeded(): boolean {
    return this.reloadCount >= this.maxReloadCount;
  }

  private get reloadCount(): number {
    return Number(this.url.searchParams.get(this.param));
  }
}
